export const adverseEventPtSearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance',
    'displayedColumns': 'default',
    'direction': 'asc'
  },
  {
    'value': '^root_ptTerm',
    'display': 'PT Term, Ascending',
    'displayedColumns': 'ptTerm',
    'direction': 'asc'
  },
  {
    'value': '$root_ptTerm',
    'display': 'PT Term, Descending',
    'displayedColumns': 'ptTerm',
    'direction': 'desc'
  },
  {
    'value': '^root_primSoc',
    'display': 'Prim SOC, Ascending',
    'displayedColumns': 'primSoc',
    'direction': 'asc'
  },
  {
    'value': '$root_primSoc',
    'display': 'Prim SOC, Descending',
    'displayedColumns': 'primSoc',
    'direction': 'desc'
  },
  {
    'value': '^root_caseCount',
    'display': 'Case Count, Ascending',
    'displayedColumns': 'caseCount',
    'direction': 'asc'
  },
  {
    'value': '$root_caseCount',
    'display': 'Case Count, Descending',
    'displayedColumns': 'caseCount',
    'direction': 'desc'
  },
  {
    'value': '^root_ptCount',
    'display': 'PT Count, Ascending',
    'displayedColumns': 'ptCount',
    'direction': 'asc'
  },
  {
    'value': '$root_ptCount',
    'display': 'PT Count, Descending',
    'displayedColumns': 'ptCount',
    'direction': 'desc'
  },
  {
    'value': '^root_prr',
    'display': 'PRR, Ascending',
    'displayedColumns': 'prr',
    'direction': 'asc'
  },
  {
    'value': '$root_prr',
    'display': 'PRR, Descending',
    'displayedColumns': 'prr',
    'direction': 'desc'
  },
  {
    'value': '^root_name',
    'display': 'Ingredient, Ascending',
    'displayedColumns': 'ingredientName',
    'direction': 'asc'
  },
  {
    'value': '$root_name',
    'display': 'Ingredient Name, Descending',
    'displayedColumns': 'ingredientName',
    'direction': 'desc'
  }
];
